<template>
  <div>
    <!-- <div class="hero simple" style="background-image: url('/static/leeno/about_first_bg.jpg')">
      <div class="content">
        <h1 class="hero-title">{{ itemTitle }}</h1>
      </div>
    </div> -->
    <div class="menu_bg">
    </div>
    <div class="product-container">
      <div class="content">
        <h1 class="hero-title">{{ $t('messages.contactUs') }}</h1>
      </div>
    </div>
    <div class="sections-container">
      <div style="width: 420px;max-height: 480px;">
        <section id="nav_menu-2" class="widget widget_nav_menu">
          <!-- <a @click="handleClick(index)">
            {{ $t(`messages.${item.title}`) }}
          </a> -->
          <h2 class="widget-title">{{ $t('messages.contactUs') }}</h2>
          <div class="menu-about-menu-container">
            <ul id="menu-about-menu" class="menu">
              <li v-for="(item, index) in menuItems" :key="item.id" :class="{ active: activeIndex === index }">
                <div class="a_container">
                  <a @click="handleClick(index)">
                    {{ $t(`messages.${item.title}`) }}
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div>

        <div v-if="activeIndex == 0">
          <div class="details-wrap">
            <div class="item-row title">
              <h3>东莞总部</h3>
            </div>
            <div class="item-row address">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22.857" viewBox="0 0 16 22.857">
                <g id="ic_place_48px" transform="translate(263 -32.082)">
                  <path id="Path_4827" data-name="Path 4827"
                    d="M18,4a8,8,0,0,0-8,8c0,6,8,14.857,8,14.857S26,18,26,12A8,8,0,0,0,18,4Zm0,10.857A2.857,2.857,0,1,1,20.857,12,2.858,2.858,0,0,1,18,14.857Z"
                    transform="translate(-273 28.082)" fill="#0077b4"></path>
                </g>
              </svg>
              <a href="https://map.baidu.com/poi/%E5%AE%89%E6%99%9F%E8%AE%AF%E4%BA%94%E9%87%91%E7%B2%BE%E5%AF%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@12651338.51068732,2591976.7371670357,18.5z?uid=4f9fac001219f5cbab0dd864&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl"
                title="Go to baidu maps" target="_blank">
                {{ $t('messages.zongbuAddr') }}
              </a>
            </div>
            <div class="item-row phone">
              <svg xmlns="http://www.w3.org/2000/svg" width="19.773" height="19.773" viewBox="0 0 19.773 19.773">
                <g id="phone" transform="translate(-0.029 0.011)">
                  <path id="Path_4825" data-name="Path 4825"
                    d="M19.044.94,15.028.013A.933.933,0,0,0,13.966.55L12.112,4.875a.924.924,0,0,0,.266,1.081l2.34,1.915a14.312,14.312,0,0,1-6.843,6.843L5.96,12.374a.926.926,0,0,0-1.081-.266L.554,13.961a.938.938,0,0,0-.541,1.066L.94,19.043a.927.927,0,0,0,.9.718A17.917,17.917,0,0,0,19.762,1.843.926.926,0,0,0,19.044.94Z"
                    transform="translate(0.04 0)" fill="#0077b4"></path>
                </g>
              </svg>
              <a href="tel:+82-51-831-3232" title="Call Us">
                {{ $t('messages.zongbuContact') }}
              </a>
            </div>
            <div class="item-row email">
              <svg xmlns="http://www.w3.org/2000/svg" width="22.787" height="17.09" viewBox="0 0 22.787 17.09">
                <g id="email-84" transform="translate(3 -1)">
                  <path id="Path_4828" data-name="Path 4828"
                    d="M22.075,4H.712A.673.673,0,0,0,0,4.712V20.378a.673.673,0,0,0,.712.712H22.075a.673.673,0,0,0,.712-.712V4.712A.673.673,0,0,0,22.075,4ZM20.366,7.418l-8.545,5.7a1.012,1.012,0,0,1-.427.142,1.012,1.012,0,0,1-.427-.142l-8.545-5.7a.753.753,0,0,1-.142-1,.753.753,0,0,1,1-.142l8.118,5.412,8.118-5.412a.7.7,0,0,1,1,.214A.675.675,0,0,1,20.366,7.418Z"
                    transform="translate(-3 -3)" fill="#0077b4"></path>
                </g>
              </svg>
              <a href="mailto:zg@dg-asx.com" title="Email Us">
                {{ zongbuEmail }}
              </a>
            </div>
            <div class="item-row link">
              <svg xmlns="http://www.w3.org/2000/svg" width="26.449" height="26.454" viewBox="0 0 26.449 26.454">
                <path id="globe"
                  d="M17.947,16.107C17.174,11.344,15.35,8,13.227,8s-3.947,3.344-4.72,8.107Zm-9.84,5.12a33.43,33.43,0,0,0,.176,3.413h9.883a33.43,33.43,0,0,0,.176-3.413,33.431,33.431,0,0,0-.176-3.413H8.283A33.43,33.43,0,0,0,8.107,21.227Zm17.318-5.12A13.255,13.255,0,0,0,17,8.555a18,18,0,0,1,2.667,7.552ZM9.451,8.555a13.246,13.246,0,0,0-8.422,7.552H6.79A17.928,17.928,0,0,1,9.451,8.555ZM26,17.814H19.878c.112,1.12.176,2.267.176,3.413s-.064,2.293-.176,3.413H25.99a13.113,13.113,0,0,0,.459-3.413A13.342,13.342,0,0,0,26,17.814ZM6.4,21.227c0-1.147.064-2.293.176-3.413H.459a12.931,12.931,0,0,0,0,6.827H6.571C6.464,23.521,6.4,22.374,6.4,21.227Zm2.107,5.12c.773,4.763,2.6,8.107,4.72,8.107s3.947-3.344,4.72-8.107ZM17,33.9a13.268,13.268,0,0,0,8.427-7.552H19.67A18,18,0,0,1,17,33.9ZM1.029,26.347A13.255,13.255,0,0,0,9.456,33.9,18,18,0,0,1,6.79,26.347H1.029Z"
                  transform="translate(0 -8)" fill="#0077b4"></path>
              </svg>
              <a href="http://leeno.com" title="Go to website" target="_blank">
                {{ zongbuWeb }}
              </a>
            </div>
          </div>

          <div class="details-wrap">
            <div class="item-row title">
              <h3>韩国分公司</h3>
            </div>
            <div class="item-row address">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22.857" viewBox="0 0 16 22.857">
                <g id="ic_place_48px" transform="translate(263 -32.082)">
                  <path id="Path_4827" data-name="Path 4827"
                    d="M18,4a8,8,0,0,0-8,8c0,6,8,14.857,8,14.857S26,18,26,12A8,8,0,0,0,18,4Zm0,10.857A2.857,2.857,0,1,1,20.857,12,2.858,2.858,0,0,1,18,14.857Z"
                    transform="translate(-273 28.082)" fill="#0077b4"></path>
                </g>
              </svg>
              <a href="https://map.baidu.com/poi/%E5%AE%89%E6%99%9F%E8%AE%AF%E4%BA%94%E9%87%91%E7%B2%BE%E5%AF%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@12651338.51068732,2591976.7371670357,18.5z?uid=4f9fac001219f5cbab0dd864&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl"
                title="Go to baidu maps" target="_blank">
                {{ $t('messages.hanguoAddr') }}
              </a>
            </div>
            <div class="item-row phone">
              <svg xmlns="http://www.w3.org/2000/svg" width="19.773" height="19.773" viewBox="0 0 19.773 19.773">
                <g id="phone" transform="translate(-0.029 0.011)">
                  <path id="Path_4825" data-name="Path 4825"
                    d="M19.044.94,15.028.013A.933.933,0,0,0,13.966.55L12.112,4.875a.924.924,0,0,0,.266,1.081l2.34,1.915a14.312,14.312,0,0,1-6.843,6.843L5.96,12.374a.926.926,0,0,0-1.081-.266L.554,13.961a.938.938,0,0,0-.541,1.066L.94,19.043a.927.927,0,0,0,.9.718A17.917,17.917,0,0,0,19.762,1.843.926.926,0,0,0,19.044.94Z"
                    transform="translate(0.04 0)" fill="#0077b4"></path>
                </g>
              </svg>
              <a href="tel:+82-51-831-3232" title="Call Us">
                {{ $t('messages.hanguoContact') }}
              </a>
            </div>
            <div class="item-row email">
              <svg xmlns="http://www.w3.org/2000/svg" width="22.787" height="17.09" viewBox="0 0 22.787 17.09">
                <g id="email-84" transform="translate(3 -1)">
                  <path id="Path_4828" data-name="Path 4828"
                    d="M22.075,4H.712A.673.673,0,0,0,0,4.712V20.378a.673.673,0,0,0,.712.712H22.075a.673.673,0,0,0,.712-.712V4.712A.673.673,0,0,0,22.075,4ZM20.366,7.418l-8.545,5.7a1.012,1.012,0,0,1-.427.142,1.012,1.012,0,0,1-.427-.142l-8.545-5.7a.753.753,0,0,1-.142-1,.753.753,0,0,1,1-.142l8.118,5.412,8.118-5.412a.7.7,0,0,1,1,.214A.675.675,0,0,1,20.366,7.418Z"
                    transform="translate(-3 -3)" fill="#0077b4"></path>
                </g>
              </svg>
              <a href="mailto:meta198@naver.com" title="Email Us">
                {{ hanguoEmail }}
              </a>
            </div>
            <div class="item-row link">
              <svg xmlns="http://www.w3.org/2000/svg" width="26.449" height="26.454" viewBox="0 0 26.449 26.454">
                <path id="globe"
                  d="M17.947,16.107C17.174,11.344,15.35,8,13.227,8s-3.947,3.344-4.72,8.107Zm-9.84,5.12a33.43,33.43,0,0,0,.176,3.413h9.883a33.43,33.43,0,0,0,.176-3.413,33.431,33.431,0,0,0-.176-3.413H8.283A33.43,33.43,0,0,0,8.107,21.227Zm17.318-5.12A13.255,13.255,0,0,0,17,8.555a18,18,0,0,1,2.667,7.552ZM9.451,8.555a13.246,13.246,0,0,0-8.422,7.552H6.79A17.928,17.928,0,0,1,9.451,8.555ZM26,17.814H19.878c.112,1.12.176,2.267.176,3.413s-.064,2.293-.176,3.413H25.99a13.113,13.113,0,0,0,.459-3.413A13.342,13.342,0,0,0,26,17.814ZM6.4,21.227c0-1.147.064-2.293.176-3.413H.459a12.931,12.931,0,0,0,0,6.827H6.571C6.464,23.521,6.4,22.374,6.4,21.227Zm2.107,5.12c.773,4.763,2.6,8.107,4.72,8.107s3.947-3.344,4.72-8.107ZM17,33.9a13.268,13.268,0,0,0,8.427-7.552H19.67A18,18,0,0,1,17,33.9ZM1.029,26.347A13.255,13.255,0,0,0,9.456,33.9,18,18,0,0,1,6.79,26.347H1.029Z"
                  transform="translate(0 -8)" fill="#0077b4"></path>
              </svg>
              <a href="http://leeno.com" title="Go to website" target="_blank">
                {{ zongbuWeb }}
              </a>
            </div>
          </div>
          <div class="details-wrap">
            <div class="item-row title">
              <h3>深圳分公司</h3>
            </div>
            <div class="item-row address">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22.857" viewBox="0 0 16 22.857">
                <g id="ic_place_48px" transform="translate(263 -32.082)">
                  <path id="Path_4827" data-name="Path 4827"
                    d="M18,4a8,8,0,0,0-8,8c0,6,8,14.857,8,14.857S26,18,26,12A8,8,0,0,0,18,4Zm0,10.857A2.857,2.857,0,1,1,20.857,12,2.858,2.858,0,0,1,18,14.857Z"
                    transform="translate(-273 28.082)" fill="#0077b4"></path>
                </g>
              </svg>
              <a href="https://map.baidu.com/poi/%E5%AE%89%E6%99%9F%E8%AE%AF%E4%BA%94%E9%87%91%E7%B2%BE%E5%AF%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@12651338.51068732,2591976.7371670357,18.5z?uid=4f9fac001219f5cbab0dd864&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl"
                title="Go to baidu maps" target="_blank">
                {{ $t('messages.shenzhenAddr') }}
              </a>
            </div>
            <div class="item-row phone">
              <svg xmlns="http://www.w3.org/2000/svg" width="19.773" height="19.773" viewBox="0 0 19.773 19.773">
                <g id="phone" transform="translate(-0.029 0.011)">
                  <path id="Path_4825" data-name="Path 4825"
                    d="M19.044.94,15.028.013A.933.933,0,0,0,13.966.55L12.112,4.875a.924.924,0,0,0,.266,1.081l2.34,1.915a14.312,14.312,0,0,1-6.843,6.843L5.96,12.374a.926.926,0,0,0-1.081-.266L.554,13.961a.938.938,0,0,0-.541,1.066L.94,19.043a.927.927,0,0,0,.9.718A17.917,17.917,0,0,0,19.762,1.843.926.926,0,0,0,19.044.94Z"
                    transform="translate(0.04 0)" fill="#0077b4"></path>
                </g>
              </svg>
              <a href="tel:+82-51-831-3232" title="Call Us">
                {{ $t('messages.shenzhenContact') }}
              </a>
            </div>
            <div class="item-row email">
              <svg xmlns="http://www.w3.org/2000/svg" width="22.787" height="17.09" viewBox="0 0 22.787 17.09">
                <g id="email-84" transform="translate(3 -1)">
                  <path id="Path_4828" data-name="Path 4828"
                    d="M22.075,4H.712A.673.673,0,0,0,0,4.712V20.378a.673.673,0,0,0,.712.712H22.075a.673.673,0,0,0,.712-.712V4.712A.673.673,0,0,0,22.075,4ZM20.366,7.418l-8.545,5.7a1.012,1.012,0,0,1-.427.142,1.012,1.012,0,0,1-.427-.142l-8.545-5.7a.753.753,0,0,1-.142-1,.753.753,0,0,1,1-.142l8.118,5.412,8.118-5.412a.7.7,0,0,1,1,.214A.675.675,0,0,1,20.366,7.418Z"
                    transform="translate(-3 -3)" fill="#0077b4"></path>
                </g>
              </svg>
              <a href="mailto:13560788801@139.com" title="Email Us">
                {{ shenzhenEmail }}
              </a>
            </div>
            <div class="item-row link">
              <svg xmlns="http://www.w3.org/2000/svg" width="26.449" height="26.454" viewBox="0 0 26.449 26.454">
                <path id="globe"
                  d="M17.947,16.107C17.174,11.344,15.35,8,13.227,8s-3.947,3.344-4.72,8.107Zm-9.84,5.12a33.43,33.43,0,0,0,.176,3.413h9.883a33.43,33.43,0,0,0,.176-3.413,33.431,33.431,0,0,0-.176-3.413H8.283A33.43,33.43,0,0,0,8.107,21.227Zm17.318-5.12A13.255,13.255,0,0,0,17,8.555a18,18,0,0,1,2.667,7.552ZM9.451,8.555a13.246,13.246,0,0,0-8.422,7.552H6.79A17.928,17.928,0,0,1,9.451,8.555ZM26,17.814H19.878c.112,1.12.176,2.267.176,3.413s-.064,2.293-.176,3.413H25.99a13.113,13.113,0,0,0,.459-3.413A13.342,13.342,0,0,0,26,17.814ZM6.4,21.227c0-1.147.064-2.293.176-3.413H.459a12.931,12.931,0,0,0,0,6.827H6.571C6.464,23.521,6.4,22.374,6.4,21.227Zm2.107,5.12c.773,4.763,2.6,8.107,4.72,8.107s3.947-3.344,4.72-8.107ZM17,33.9a13.268,13.268,0,0,0,8.427-7.552H19.67A18,18,0,0,1,17,33.9ZM1.029,26.347A13.255,13.255,0,0,0,9.456,33.9,18,18,0,0,1,6.79,26.347H1.029Z"
                  transform="translate(0 -8)" fill="#0077b4"></path>
              </svg>
              <a href="http://leeno.com" title="Go to website" target="_blank">
                {{ zongbuWeb }}
              </a>
            </div>
          </div>
        </div>
        <div v-if="activeIndex == 1">
          <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
            <div style="font-size: 30px;color: #6f6f6f;">{{ $t('messages.labelContactUs') }} </div>
            <el-card shadow="always" class="form-container" :body-style="{ 'flex-direction': 'column', display: 'flex' }">
              <el-form label-position="left" label-width="80px" :model="formData">
                <el-form-item :label="$t('messages.labelName')">
                  <el-input v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('messages.labelPhone')">
                  <el-input v-model="formData.phone"></el-input>
                </el-form-item>
                <el-form-item :label="$t('messages.labelEmail')">
                  <el-input v-model="formData.email"></el-input>
                </el-form-item>
                <el-form-item :label="$t('messages.labelCompany')">
                  <el-input v-model="formData.company"></el-input>
                </el-form-item>
                <el-form-item :label="$t('messages.labelCountry')">
                  <el-input v-model="formData.country"></el-input>
                </el-form-item>
                <el-form-item :label="$t('messages.labelMessage')">
                  <el-input v-model="formData.message" type="textarea" :rows="3"></el-input>
                </el-form-item>
              </el-form>
              <el-button style="background-color: #0077b4;" type="primary" size="large" @click="handleSubmit">{{ $t('messages.textSubmit') }}</el-button>
            </el-card>

          </div>

        </div>
        <div v-if="activeIndex == 2">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // components: {
  //   CategoryMenu
  // }
  data() {
    return {
      activeIndex: 0,
      menuItems: [
        { id: 1001, title: 'addrTitle' },
        // { id: 1002, title: 'branchsTitle' },
        { id: 1004, title: 'moreInfoTitle' },
        // { id: 1003, title: 'historyAwards' },
        // { id: 1005, title: 'certification' },
      ],
      zongbuWeb: "https://asx-probe.com",
      zongbuEmail: "zg@dg-asx.com",
      hanguoEmail: "meta198@naver.com",
      shenzhenEmail: "13560788801@139.com",
      formData: {
        name: '',
        phone: '',
        email: '',
        company: '',
        message: '',
        country: ''
      }
    };
  },

  mounted() {
    this.activeIndex = this.$route.params.index || 0
    // this.loadBMapScript();
  },
  computed: {
    itemTitle() {
      // console.log(this.activeIndex)
      // console.log(this.menuItems[this.activeIndex])
      return this.$t(`messages.${this.menuItems[this.activeIndex].title}`)
    }
  },
  methods: {
    handleClick(index) {
      this.activeIndex = index;
    },

    handleSubmit() {

    }
    // loadBMapScript() {
    //   if (window.BMap) {
    //     // 如果百度地图API已经存在，则直接初始化地图
    //     this.initMap();
    //   } else {
    //     // 动态加载百度地图API脚本
    //     const script = document.createElement('script');
    //     script.src = 'https://api.map.baidu.com/api?v=3.0&ak=uqt3QzwPxAYwLFcgSWTCbbqIqCfS5eBm';
    //     script.type = 'text/javascript';
    //     script.onload = () => {
    //       // 脚本加载完成后设置标志位为true并初始化地图
    //       this.baiduMapLoaded = true;
    //       this.initMap();
    //     };
    //     script.onerror = () => {
    //       console.error('Failed to load Baidu Map API.');
    //     };
    //     document.body.appendChild(script);
    //   }
    // },
    // initMap() {
    //   if (!this.baiduMapLoaded) {
    //     console.warn('Baidu Map API is not ready yet.');
    //     return;
    //   }

    //   try {
    //     const map = new BMap.Map("allmap"); // 创建Map实例
    //     const point = new BMap.Point(116.404, 39.915); // 创建点坐标 (经度, 纬度)
    //     map.centerAndZoom(point, 15); // 初始化地图,设置中心点坐标和地图级别
    //     map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
    //   } catch (error) {
    //     console.error('Error initializing Baidu Map:', error);
    //   }
    // }
  }
};
</script>

<style scoped>
.menu_bg {
  height: 100px;
  width: 100%;
  position: relative;
  background-size: cover;
  background-color: #00579C;
}

.product-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.product-container .content {

  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg,
      var(--unnamed-color-0077b4) 0%,
      rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  padding: 24px 0 18px 73px;
}

.content .hero-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 46px;
}

.hero.simple {
  height: 475px;
  width: 100%;
  position: relative;
  background-size: cover;
}

.hero.simple:after {
  z-index: 1;
  content: "";
  background: rgba(0, 0, 0, 0) linear-gradient(180deg, #000000 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.5;
}

@media (max-width: 1539px) {
  .hero.simple .content {
    padding: 24px 0 18px 48px;
  }
}

.hero.simple .content {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg,
      var(--unnamed-color-0077b4) 0%,
      rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  padding: 24px 0 18px 73px;
}

.hero.simple .hero-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 46px;
}

@media (max-width: 1539px) {
  .sections-container {
    -webkit-padding-start: 49px;
    padding-inline-start: 49px;
    -webkit-padding-end: 49px;
    padding-inline-end: 49px;
    gap: 70px;
  }
}

@media (max-width: 1919px) {
  .sections-container {
    gap: 80px;
  }
}

.sections-container {
  display: flex;
  /* justify-content: space-between; */
  margin-top: 54px;
  -webkit-padding-start: 70px;
  padding-inline-start: 70px;
  -webkit-padding-end: 70px;
  padding-inline-end: 70px;
}


.widget_nav_menu {
  padding: 24px 0;
}

.widget {
  margin: 0 0 1.5em;
}

.widget_nav_menu {
  width: 100%;
  height: 100%;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, .1607843137);
  border-radius: 10px;
  background-color: #fafafa;
  padding-top: 24px;
}

.widget_nav_menu h2 {
  margin: 0;
  font-size: 37px;
  line-height: 56px;
  color: #0077b4;
  -webkit-padding-start: 40px;
  padding-inline-start: 40px;
}

.widget_nav_menu .menu-about-menu-container ul {
  list-style: none;
  margin: 10px 0 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.widget_nav_menu .menu-about-menu-container ul li {
  height: 54px;
  padding-top: 12px;
}

.widget_nav_menu .menu-about-menu-container ul li:hover {
  background-color: #ddd;
}

.widget_nav_menu .menu-about-menu-container ul li.active {
  background-color: #ccc;
}

.widget_nav_menu .menu-about-menu-container ul li a {
  text-decoration: none;
  font-size: 17px;
  color: #6f6f6f;
  -webkit-padding-start: 40px;
  padding-inline-start: 40px;
  transition: linear-gradient .2s ease-in-out;
}

/* 新增的样式 */
.a_container {
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.menu a {
  text-decoration: none;
  cursor: pointer;
  background-color: transparent;
  color: black;
  padding: 5px 10px;
}

.menu a:hover {
  background-color: #ddd;
}

.menu a.active {
  background-color: #ccc;
}

.details-wrap {
  display: flex;
  flex-direction: column;
  gap: 13px;
  border-bottom: 3px dashed rgba(40, 80, 124, .15);
  padding-bottom: 20px;
}

.title .address .phone {
  display: flex;
  flex-direction: row;
  gap: 10px;
  max-width: 750px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  clear: both;
  color: #29517c;
  font-weight: 600;
  font-size: 30px;
}

a {
  text-decoration: none;
  font-size: 20px;
  color: #6f6f6f;
  line-height: 24px;
}

.form-container {
  margin-top: 10px;
  padding: 20px;
  width: 600px;
  display: flex;
  flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/components/firstLevel/Contact.vue